import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';
import { UserStatus, UserRole } from '../types';

type UpdateUserRequest = {
  firstName?: string;
  lastName?: string;
  emailAddress?: string;
  userRole?: UserRole;
  userStatus?: UserStatus;
};

export function useUpdateUser() {
  const queryClient = useQueryClient();

  const {
    mutateAsync,
    error,
    isPending: isLoading,
    reset,
  } = useMutation<{ data: unknown }, Error, { id: string; values: UpdateUserRequest }>({
    mutationFn: ({ id, values }) => api.patch(`users/${id}`, values),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['users'] });
    },
  });

  const updateUser = async (id: string, values: UpdateUserRequest) => {
    return mutateAsync({ id, values });
  };

  return {
    updateUser,
    error,
    isLoading,
    reset,
  };
}
